import { render, staticRenderFns } from "./choiseListTable.vue?vue&type=template&id=f2d65f6e&scoped=true"
import script from "./choiseListTable.vue?vue&type=script&lang=js"
export * from "./choiseListTable.vue?vue&type=script&lang=js"
import style0 from "./choiseListTable.vue?vue&type=style&index=0&id=f2d65f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d65f6e",
  null
  
)

export default component.exports